import MIS from '@/views/mis/lang/lang-cn'
import CRS from '@/views/crs/lang/lang-cn'
import PAGE from '@/components/page/lang/lang-cn'
import IM from '@/views/IM/lang/lang-cn'
import ANALYSE from '@/views/analyse/lang/lang-cn'
import OTHER from '@/views/other/lang/lang-cn'
import TREXMIS from '@/views/newmis36/lang/lang-cn'
import CRS36 from '@/views/crs36/lang/lang-cn'

export const login = {
  login: '登录',
  choiceProject: '请选择项目',
  choiceLang: '请选择语言',
  password: '密码'
}
export const common = {
  operation:"操作",
  edit: '编辑',
  add: '增加',
  delete: '删除',
  date: '日期',
  remark: '备注',
  handle: '操作',
  stop: '停用',
  start: '启用',
  search: '查询',
  reset: '重置',
  nodata: '暂无数据',
  cancle: '取消',
  ok: '确定',
  addNew: '新增',
  layOut: '退出',
  status: '状态',
  tip: '提示',
  import: '导入',
  export: '导出',
  detail: '详情',
  ifDelete: '是否删除?',
  conDelete: '删除成功!',
  canDele: '已取消删除',
  ifStatus: '是否禁用?',
  ifStatus1: '是否启用?',
  conStatus: '禁用成功!',
  conStatus1: '启用成功!',
  canStatus: '已取消!',
  changeSu: '修改成功',
  addSu: '添加成功',
  canceld: '已取消',
  rulesText: '内容不能为空',
  trackerAuth: '用户追踪授权',
  approve: '同意',
  reject: '拒绝',
  show: '显示',
  hide: '隱藏',
  preview: '预览',
}
export const menu = {
  chName: '中文名称',
  enName: '英文名称',
  vnName: '越南文名称',
  component: '组件名称',
  pathName: '访问路径',
  comPath: '组件路径',
  choiceIcon: '选择图标',
  icon: '图标',
  sort: '排序值',
  editMenu: '编辑菜单',
  addMenu: '新增菜单'
}
export const role = {
  addRole: '新增角色',
  role: '角色',
  editRoleName: '编辑角色',
  roleName: '角色名称',
  menuControl: '菜单权限'
}
export const user = {
  addUser: '新增用户',
  user: '角色',
  editUserName: '编辑用户',
  companyChoice: '公司选择',
  roleChoice: '角色选择',
  businessChoice: '任务选择',
  nickName: '昵称',
  loginName: '登录名',
  email: '邮箱',
  phone: '手机号',
  userStatus: '用户状态',
  resetPass: '重置密码'
}
export const whiteList = {
  synchronism: '同步',
  platFormName: '平台名',
  modules: '模块',
  domain: '域名',
  gateWay: '网关'
}
export const company = {
  companyName: '业务名称',
  bandGate: '绑定网关',
  resetKey: '重置key',
  businessChioce: '业务选择',
  businessHolder: '请选择业务'
}
export const job = {
  jobName: '任务名称',
  jobClass: '任务分组',
  jobDes: '任务描述',
  jobDo: '任务执行类',
  cron: 'cron表达式',
  wait: '等待',
  pause: '暂停',
  executed: '正常执行',
  block: '阻塞',
  error: '错误',
  startOff: '触发',
  pauseJob: '暂停任务',
  backJob: '恢复任务',
  confimStart: '你确认要触发该任务?',
  startSucc: '触发成功'
}
export const message = {
  messageClass: '推送类别',
  type: '类型',
  moduleCode: '模板code',
  content: '内容',
  ipLimit: 'ip上限',
  phoneLimit: '手机上限',
  time: '指定时间',
  sendType: '发送类别',
  ipHolder: '一个IP一天内可以发多少次短信验证码',
  phoneHolder: '一个手机一天内可以发多少次短信验证码',
  timeHolder: '发送短信是否在指定时间内(默认60秒有效期)',
  autoSend: '自动发送',
  timeSend: '定时发送',
  otherMessage: '其他通知类短信',
  verification: '验证码'
}
export const gateWay = {
  programId: '项目id',
  programName: '项目名称',
  predicates: 'predicates',
  gateUri: '网关Uri',
  Gateway: '网关'
}
export const thisCompany = {
  companyName: '公司名称',
  companyCode: '公司编码',
  loginName: '登录名',
  niceName: '用户昵称',
  phone: '手机号码'
}
export const menuName = {
  home: '首页',
  sysName: '系统管理',
  menuManage: '菜单管理',
  userManage: '用户管理',
  whiteManage: '白名单管理',
  compangManage: '公司管理',
  jobManage: '任务管理',
  messageManage: '短信管理',
  gateWayManage: '网关管理',
  businessManage: '业务管理',
  myCompany: '我的公司',
  companyBasic: '公司基本信息'
}
export const sms = {
  batchSend: '批量发送'
}

export const mis = MIS
export const crs = CRS
export const crs36 = CRS36
export const page = PAGE
export const im = IM
export const analyse = ANALYSE
export const other = OTHER
export const txmis = TREXMIS
